import React from 'react';
import {NavLink} from 'react-router-dom';
import {Translate} from '../../config/TranslationProvider';
import classNames from 'classnames';
import { useRoute } from '../../routing/RouteProvider';
import NavbarSearchForm from '../filter/NavbarSearchForm';
import {usePages} from '../../api/hooks';
import Loader from '../pages/Loader';
import Error from '../pages/Error';

const RouteMenuItem = ({title, routeName, classes}) => {
    const href = useRoute(routeName);

    return (
        <li className={classes}>
            <NavLink to={href} aria-label={title}><Translate value={title} /></NavLink>
        </li>
    );
};
const ExternalMenuItem = ({title, href, classes}) => (
    <li className={classes}>
        <a href={href} target="_blank" rel="noopener noreferrer" aria-label={title}>
            <Translate value={title} />
        </a>
    </li>
);
const MenuItem = ({link: {title, routeName, href, isExternal}, classes}) => {
    if (isExternal) {
        return <ExternalMenuItem title={title} href={href} classes={classes} />;
    }

    return <RouteMenuItem title={title} routeName={routeName} classes={classes} />;
};

const AppLinks = ({links, pos}) => {
    const classes = classNames({
        'page-item': pos === 'footer'
    });

    return (
        <>
            {Object.values(links).map((link, key) => (
                <MenuItem key={key} link={link} classes={classes} />
            ))}
        </>
    );
};

const ApiLinks = () => {
    const {data: pages, isLoading, error} = usePages();

    if (isLoading) {
        return (
            <Loader />
        );
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    return (
        <>
            {pages.map(({path, title}) => (
                <li key={path} className="page-item footer-only">
                    <NavLink to={'/' + path} aria-label={title}><Translate value={title} /></NavLink>
                </li>
            ))}
        </>
    );
};

const Menu = ({links, pos}) => (
    <>
        <NavbarSearchForm className="mobile-menu" />

        <AppLinks links={links} pos={pos} />

        <ApiLinks />
    </>
);

export default Menu;
